<!-- PrimeNG Dialog for the modal mechanics (focus trap, Esc, backdrop); the
     header is switched off and the body below is the Figma card. The panel is
     appended to <body>, so its frame styling lives in styles.css under
     .logout-dialog; only the content is styled here. -->
<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [showHeader]="false"
    [dismissableMask]="!busy()" [closeOnEscape]="!busy()" [focusOnShow]="true" styleClass="logout-dialog"
    appendTo="body" aria-labelledby="logout-title">

    <div class="body">
        <span class="icon" aria-hidden="true">
            <img src="assets/dashboard/icon-alert-triangle.svg" alt="" width="40" height="40" />
        </span>
        <h2 id="logout-title" class="title">Log out ?</h2>
        <p class="text">
            Are you sure you want to log out of your account ?<br />
            you can sign in again any time.
        </p>
    </div>

    <div class="actions">
        <button type="button" class="btn btn--ghost" [disabled]="busy()" (click)="confirm()">
            {{ busy() ? 'Logging out...' : 'Log out' }}
        </button>
        <button type="button" class="btn btn--danger" [disabled]="busy()" (click)="cancel()" autofocus>
            Cancel
        </button>
    </div>

</p-dialog>
